var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"373117fb18216d0bdf06a515884b93b1166b875e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["keysy-web@axone"]={id:"373117fb18216d0bdf06a515884b93b1166b875e"};
      